<template>
  <div>
    <el-dialog
      v-if="visible"
      show-close
      :visible="visible"
      width="400px"
      :title="$l('dialog_title_setOperate') || '更新运营人员'"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
    >
      <Main
        ref="main"
        :listCode="listCode"
        @close="close"
        @reload="$emit('reload')"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button type="primary" size="small" @click="$refs.main.save()">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    listCode: { type: Array, default: () => [] },
  },
  data() {
    return {
      backDialogVisible: false,
    }
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style scoped></style>
